export default {
  path: '/quality_checks',
  name: 'quality_checks',
  component: () => import('../components/qualitycheck/Layout'),
  redirect: { name: 'QualityCheckList' },
  meta: {
    breadcrumb: 'qualitycheck.qualitycheck.checks',
  },
  children: [
    {
      name: 'QualityCheckList',
      path: '',
      component: () => import('../views/qualitycheck/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    /*{
      name: 'QualityCheckSpecList',
      path: 'listSpec',
      component: () => import('../views/qualitycheck/ListSpec'),
      meta: {
        breadcrumb: 'global.list',
      },
    },*/
    {
      name: 'QualityCheckCreate',
      path: 'new',
      component: () => import('../views/qualitycheck/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'QualityCheckUpdate',
      path: ':id/edit',
      component: () => import('../views/qualitycheck/Update'),
      meta: {
        breadcrumb: 'qualitycheck.qualitycheck.check',
      },
    },
    {
      name: 'QualityCheckShow',
      path: ':id',
      component: () => import('../views/qualitycheck/Show'),
      meta: {
        breadcrumb: 'qualitycheck.qualitycheck.check',
      },
    },
    {
      name: 'QualityCheck',
      path: ':parent',
      component: () => import('../components/qualitycheckvalue/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.qualitycheck.qualitycheckvalues',
      },
      children: [
        {
          name: 'QualityCheckValueCreate',
          path: 'new',
          component: () => import('../views/qualitycheckvalue/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
        {
          name: 'QualityCheckValueUpdate',
          path: ':id/edit',
          component: () => import('../views/qualitycheckvalue/Update'),
          meta: {
            breadcrumb: 'qualitycheck.qualitycheck.qualitycheckvalue',
          },
        },
        {
          name: 'QualityCheckValueShow',
          path: ':id',
          component: () => import('../views/qualitycheckvalue/Show'),
          meta: {
            breadcrumb: 'qualitycheck.qualitycheck.qualitycheckvalue',
          },
        }
      ]

    },
  ]
};
